import { useSelector } from 'react-redux'
import type { RootState } from 'reducers'

export const useCurrentUserId = () => useSelector((s: RootState) => s.app.user.id)
